'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var index_m = require('../../use-stateful-ref/lib/index.m.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function o(t, u = { isStateful: !0 }) {
  const n = index_m['default'](null), f = React.useRef(null), e = u.isStateful ? n : f;
  return React__default['default'].useEffect(() => {
    !t || (typeof t == "function" ? t(e.current) : t.current = e.current);
  }), e;
}

exports.default = o;
exports.useForwardedRef = o;
//# sourceMappingURL=index.m.js.map
